export interface IConsents {
  ad_storage: string;
  ad_user_data: string;
  ad_personalization: string;
  analytics_storage: string;
  functionality_storage: string;
  personalization_storage: string;
  security_storage: string;
}

export enum consentPopupsEvents {
  OPENCONFIGPOPUP = 'openConfigPopup',
  CLOSECONFIGPOPUP = 'closeConfigPopup',
  OPENMAINPOPUP = 'openMainPopup',
  CLOSEMAINPOPUP = 'closeMainPopup',
}
